import { Outlet, type RouteObject } from 'react-router-dom';
import { CONTEXTS } from '@/app/registry';

export const adminTestsRoutes: RouteObject[] = [
  {
    path: 'admin/tests',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_TESTS, title: 'Tests techniques' },
  },
  {
    path: 'admin/tests/new',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_TEST_FORM, title: 'Nouveau test' },
  },
  {
    path: 'admin/tests/:testKey/edit',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_TEST_FORM, title: 'Modifier le test' },
  },
];
